import RelationActions from './Actions'
import { Chip } from '@mui/material'

export const getColumns = (onEdit, onDelete, onRefresh, onReassign) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', width: 70 },
  {
    field: 'canton_nombre',
    headerName: 'Cantón',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
    valueGetter: params => params.row.canton?.name || params.row.canton?.nombre || params.row.canton_nombre || '-',
  },
  {
    field: 'tenant_nombre',
    headerName: 'Tenant',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
    valueGetter: params => params.row.tenant?.name || params.row.tenant?.nombre || params.row.tenant_nombre || '-',
  },
  {
    field: 'orden',
    headerName: 'Orden',
    headerAlign: 'center',
    flex: 0.8,
    minWidth: 70,
    type: 'number',
  },
  {
    field: 'es_principal',
    headerAlign: 'center',
    headerName: 'Principal',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Sí' : 'No'}
        color={params.value ? 'primary' : 'default'}
        size="small"
        variant={params.value ? 'filled' : 'outlined'}
      />
    ),
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Estado',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Activo' : 'Inactivo'}
        color={params.value ? 'success' : 'default'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'treeCount',
    headerName: 'Árboles',
    headerAlign: 'center',
    align: 'center',
    flex: 0.8,
    minWidth: 80,
    type: 'number',
    valueGetter: params => params.row.treeCount ?? 0,
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => (
      <RelationActions {...{ params, onEdit, onDelete, onRefresh, onReassign }} />
    ),
    minWidth: 190,
    flex: 2,
  },
]
